import { RECEIVE_LINKED_ACCOUNTS, REQUEST_LINKED_ACCOUNTS, UPDATE_USER, UPDATE_USER_PROFILE } from '@Actions/currentUserActions';
export const defaultState = {
    user: window.USER,
    userProfile: window.USER_PROFILE,
    cards: null
};
export function currentUserReducer(state = defaultState, action) {
    switch (action.type) {
        case UPDATE_USER:
            return Object.assign(Object.assign({}, state), { user: Object.assign(Object.assign({}, state.user), action.payload) });
        case UPDATE_USER_PROFILE:
            return Object.assign(Object.assign({}, state), { userProfile: Object.assign(Object.assign({}, state.userProfile), action.payload) });
        case RECEIVE_LINKED_ACCOUNTS:
            return Object.assign(Object.assign({}, state), { cards: action.linkedAccounts });
        case REQUEST_LINKED_ACCOUNTS:
            return Object.assign(Object.assign({}, state), { cards: null });
        default:
            return state;
    }
}
